import withMatcher from '#/utils/withMatcher';
import { IArtist } from '../reducers/artist';

export const createActionArtistAddDetails = withMatcher((payload: IArtist) => {
  return {
    type: 'artist/add_details',
    payload,
  };
});

export const createActionArtistStartLoading = withMatcher(() => {
  return {
    type: 'artist/start_loading',
  };
});

export const createActionArtistStopLoading = withMatcher(() => {
  return {
    type: 'artist/stop_loading',
  };
});

export const createActionArtistErrorDetails = withMatcher(() => {
  return {
    type: 'artist/error_details',
  };
});

export const createActionArtistSetAlbumType = withMatcher((payload: string) => {
  return {
    type: 'artist/set_album_type',
    payload,
  };
});

export const createActionArtistSetAlbums = withMatcher(
  (payload: IArtist['albums']) => {
    return {
      type: 'artist/set_albums',
      payload,
    };
  }
);

export const createActionArtistSetIsFollowed = withMatcher(
  (payload: boolean) => {
    return {
      type: 'artist/set_is_followed',
      payload,
    };
  }
);

export const createActionArtistSetTrackIsFavorite = withMatcher(
  (payload: { track: string; favorite: boolean }) => {
    return {
      type: 'artist/set_track_is_followed',
      payload,
    };
  }
);

export const createActionArtistReset = withMatcher(() => {
  return {
    type: 'artist/reset',
  };
});
